import { useQuery } from '@tanstack/react-query';
import type { ExportRequestsResponse } from '@/features/agent/export_requests/types/ExportRequest';

export default function useFetchExportRequests() {
  return useQuery({
    queryKey: ['export_requests'],
    queryFn: async () => {
      const response = await fetch('/agent/api/export_requests');
      const data: ExportRequestsResponse = await response.json();

      return data;
    },
  });
}
